export default __webpack_public_path__ + "static/media/Accounting advisory.62802630.png";